import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Soft prompt shown during the grace window after an org switches 2FA to
 * `required` but before enforcement kicks in. Dismissible per session.
 */
export default function MfaNagBanner() {
  const { mfaNag, mfaGraceEndsAt } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  if (!mfaNag || dismissed) return null;

  const days = mfaGraceEndsAt ? Math.max(0, Math.ceil((mfaGraceEndsAt - Date.now()) / (24 * 3600 * 1000))) : null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[55] flex items-center gap-3 px-4 py-2.5 bg-status-warning/10 border-b border-status-warning/30 text-sm backdrop-blur-sm">
      <ShieldAlert className="w-4 h-4 text-status-warning shrink-0" />
      <span className="flex-1 text-foreground">
        Your organization requires two-factor authentication.
        {days != null && days > 0 ? ` Set it up within ${days} day${days === 1 ? '' : 's'}.` : ' Please set it up now.'}{' '}
        <Link to="/settings?tab=two-factor" className="font-medium text-accent-blue hover:underline">Set up 2FA</Link>
      </span>
      <button onClick={() => setDismissed(true)} className="text-muted-foreground hover:text-foreground" aria-label="Dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
